<div class="container mt-4">
  <div class="row">
    <div class="col-md-7">
      <img
        style="width: 100%; max-height: 500px; border-radius: 15px"
        [src]="product?.image"
        class="img-fluid"
        alt="{{ product?.name }}"
      />
    </div>
    <div class="col-md-5">
      <h2 class="mt-2">
        {{ product?.name }}
        <span style="font-size: 22px">
          <span style="font-size: 18px">$</span>{{ product?.price }}
        </span>
      </h2>

      <div style="margin-bottom: 16px" class="avCountry mt-2">
        <span *ngFor="let cou of product.countryOffer">
          {{ cou }}
        </span>
      </div>

      <div class="row">
        <div class="col-md-7">
          <p>
            <i style="font-size: 21px" class="fa fa-clock-o"></i>
            {{ product?.cookingTime }} minutes Cooking Time
          </p>
        </div>
        <div class="col-md-5">
          <p style="color: goldenrod; font-size: 18px">
            <strong>
              <i style="margin-right: 5px" class="fa fa-star"></i>
              <i style="margin-right: 5px" class="fa fa-star"></i>
              <i style="margin-right: 5px" class="fa fa-star"></i>
              <i style="margin-right: 5px" class="fa fa-star"></i>
              <i style="margin-right: 5px" class="fa fa-star-half-empty"></i>
            </strong>
          </p>
        </div>
      </div>

      <div class="category-tags mb-2">
        <span
          style="
            background-color: goldenrod;
            border-radius: 0;
            font-weight: 200;
          "
          *ngFor="let category of product?.category; let i = index"
          class="badge badge-pill badge-info"
        >
          {{ category }}
        </span>
      </div>

      <p style="margin-bottom: 0">{{ product?.description }}</p>

      <button class="btn btn-theme mt-3" (click)="addToCart(product)">
        Add to Cart
      </button>

      <button class="btn btn-theme mt-3 ms-2" [routerLink]="['/products']">
        Back to Product
      </button>
    </div>
  </div>

  <div class="mt-4" style="text-align: center">
    <h2 style="color: #888" class="title">Related Products</h2>
    <p>
      Indulge in a variety of delicious cuisines, offering something for every
      craving, all in one vibrant food court. From fresh, flavorful meals to
      sweet treats, enjoy a diverse range of options that cater to every taste
      and preference
    </p>
  </div>

  <div class="carousel-wrapper">
    <div style="width: 90%; margin: 0 auto">
      <div class="slick-carousel" *ngIf="relatedProducts.length">
        <div
          *ngFor="let card of relatedProducts | slice : 7 : 11"
          class="card-container m-3"
        >
          <div class="card home position-relative">
            <div class="image-container">
              <img [src]="card.image" class="card-img-top" [alt]="card.name" />
              <div
                class="overlay d-flex justify-content-center align-items-center"
              >
                <button
                  title="Add to cart"
                  class="btn btn-theme"
                  (click)="addToCart(card)"
                >
                  <i style="font-size: 24px" class="fa fa-shopping-basket"></i>
                </button>
              </div>
            </div>
            <div class="card-body red text-center">
              <h6 class="card-title">{{ card.name }}</h6>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
